var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('vue-headful',{attrs:{"title":_vm.dynamicTitle}}),_c('div',{staticClass:"playlist container page-margin"},[(_vm.playlistEnabled)?_c('span',[_c('playlist-list')],1):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }